import { render, staticRenderFns } from "./feriado.vue?vue&type=template&id=9b9c7f42&"
import script from "./feriado.vue?vue&type=script&lang=js&"
export * from "./feriado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports